import { render, staticRenderFns } from "./TransactionDetailComponent.vue?vue&type=template&id=b19b6dba"
import script from "./TransactionDetailComponent.vue?vue&type=script&lang=js"
export * from "./TransactionDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./TransactionDetailComponent.vue?vue&type=style&index=0&id=b19b6dba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports